module.exports = __webpack_public_path__ + "img/gift_un.963b1b35.png";